<template>
  <div>
    <header id="header">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <a href="/" class="logo">
              <img :src="config.logo.logo_with_icon">
            </a>
          </div>
          <div class="col-6 search-bar-container">
            <input
              type="text"
              class="form-control search-bar"
              placeholder="Enter your location"
              v-model="searchTerm"
              @keyup.enter="search"
            />
            <button class="btn btn-default" @click="search">
              <i class="cs-search"></i>
            </button>
          </div>
          <div class="col-2 text-right">
            <router-link tag="a" to="login" class="login">
              <span>
                <img src="/overt/img/login.svg" />
                Login
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <DepotList
      :depots="depots"
      @depot-clicked="depotClicked"
      :selectedDepot="selectedDepot"
    />

    <MapComponent
      :models="depots"
      @onMarkerPress="changeSelectedDepot"
      ref="map"
      :isLoading="!ready"
      :myGeometry="myGeometry"
    />
  </div>
</template>

<script>
import MapComponent from "@/components/map/MapComponent";
import DepotList from "./DepotList";
import { GoogleService } from "../../../services";

const googleService = new GoogleService();

export default {
  name: "return-locations",
  data() {
    return {
      depots: this.$route.params.depots,
      selectedDepot: null,
      searchTerm: "",
      ready: true,
      myGeometry: null
    };
  },
  methods: {
    changeSelectedDepot(depot) {
      this.selectedDepot = depot;
    },
    depotClicked(depot) {
      this.changeSelectedDepot(depot);
      this.$refs.map.onMarkerPress(depot);
    },
    async search() {
      this.ready = false;
      const geometry = this.searchTerm ? await googleService.findByCity(this.searchTerm) : null;
      this.myGeometry = geometry;

      axios.post(`${config.app.api_url}/return-locations/search`, {
        coordinates:
          geometry && geometry.location
            ? {
                latitude: geometry.location.lat,
                longitude: geometry.location.lng
              }
            : null
      }).then(res => {
        this.depotClicked(res.data[0])
        this.ready = true
        this.myGeometry?.location && this.$refs.map.panTo(this.myGeometry.location)
      })
    }
  },
  components: {
    MapComponent,
    DepotList
  }
};
</script>
